module.exports = __webpack_public_path__ + "static/media/kush-patel.afe18188.jpg";